import { RadioGroup, FormControl, FormLabel, FormControlLabel, Radio, FormHelperText } from "@mui/material";
import { Controller } from "react-hook-form";
import _ from "lodash";

const GenderField = ({ control, name, label, rules, required, helperText, ...props }) => {
  const controllerRules = rules || { required };

  const labelWithRequired = `${label}${required ? "*" : ""}`;

  return (
    <Controller
      control={control}
      name={name}
      rules={controllerRules}
      render={({
        field,
        fieldState: { error }
       }) => (
        <>
          <FormControl error={!_.isEmpty(error)}>
            <FormLabel>{labelWithRequired}</FormLabel>
            <RadioGroup row {...field} {...props}>
              <FormControlLabel value="m" control={<Radio />} label="M" />
              <FormControlLabel value="f" control={<Radio />} label="F" />
              <FormControlLabel value="o" control={<Radio />} label="Otro" />
            </RadioGroup>
          </FormControl>
        </>
      )}
    />
  );
};

export default GenderField;
